// extracted by mini-css-extract-plugin
export default {"container":"styles_container__MrEgf","img":"styles_img__tUbiW","text":"styles_text__ROJJv"};